import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import classnames from 'classnames';

import { TInquiryStatus } from '@interfaces/inquiries';
import {
  inquiryDetailsSelector,
  isInStatusSelector,
} from '@store/features/inquiryDraft/inquiryDetails/selectors';

import { INewSupplementForReviewCTACardProps } from './NewSupplementForReviewCTACard.interface';

import './style.scss';

const NewSupplementForReviewCTACard: FC<INewSupplementForReviewCTACardProps> = ({
  className,
  onClick,
}) => {
  const { t } = useTranslation();
  const cardClasses = classnames({ [`${className}`]: !!className }, 'submit-new-supplement-cta');

  const inquiryDetails = useSelector(inquiryDetailsSelector);
  const isInDraft = useSelector(isInStatusSelector(TInquiryStatus.Draft));

  return (
    <Box className={cardClasses}>
      <p className="caption">{t('dietarySupplementInquiry.notSeeingMed')}</p>

      <Button variant="text" onClick={onClick} disabled={!!inquiryDetails && !isInDraft}>
        <span className="submit-new-supplement-cta__button-text">
          {t('dietarySupplementInquiry.addANewSupplementForReview')}
        </span>
      </Button>
    </Box>
  );
};

export default NewSupplementForReviewCTACard;
